import $ from 'jquery';
import { StickyOverview } from './sticky-overview';

export function start() {
  $(document).ready(function() {
    const stickOverview = new StickyOverview({
      $el: $('[data-sticky-element]')
    });

    stickOverview.init();
  });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/layout/sticky-overview/index.js
 **/